(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const product = document.querySelector('.hpg-pdp-mobile-refresh');
  if (!product) return;

  const info = product.querySelector('.product__info-container');
  const gallery = product.querySelector('media-gallery');
  const thumbnails = gallery?.querySelector('[id^="GalleryThumbnails"]');
  const vendor = info?.querySelector('.product__text.caption-with-letter-spacing');
  const title = info?.querySelector('.product__title');
  const reviews = info?.querySelector('.product-reviews-block');
  const rating = reviews?.querySelector('.product-reviews-block__custom-rating');
  const ratingOrigin = rating?.parentElement;
  const price = info?.querySelector('.main-product-price');
  const sticky = product.querySelector('[data-hpg-mobile-sticky-cart]');
  const realButton = info?.querySelector('.product-form__submit');
  const originalNodes = [vendor, title, reviews, price].filter(Boolean).map((node) => {
    const marker = document.createComment(`hpg-mobile-origin-${node.className}`);
    node.before(marker);
    return { node, marker };
  });
  let mobileSummary;
  let syncStickyVisibility = () => {};

  function setStickyVisible(visible) {
    if (!sticky) return;
    const shouldHide = !visible;
    if (sticky.hidden !== shouldHide) sticky.hidden = shouldHide;
    document.body.classList.toggle('hpg-sticky-cart-visible', visible);
  }

  function setMobileLayout() {
    if (!mobile.matches || !thumbnails || !title || !price) return;
    if (!mobileSummary) {
      mobileSummary = document.createElement('div');
      mobileSummary.className = 'hpg-pdp-mobile-summary';
    }
    info.prepend(mobileSummary);
    vendor?.remove();
    reviews?.remove();
    mobileSummary.append(title);
    if (rating) mobileSummary.append(rating);
    mobileSummary.append(price);
  }

  function setDesktopLayout() {
    if (mobile.matches) return;
    if (rating && ratingOrigin) ratingOrigin.append(rating);
    originalNodes.forEach(({ node, marker }) => marker.after(node));
    mobileSummary?.remove();
  }

  function applyLayout() {
    if (mobile.matches) setMobileLayout();
    else setDesktopLayout();
  }

  function updateSticky() {
    if (!sticky || !info) return;
    const variantData = info.querySelector('variant-selects [data-selected-variant]');
    if (variantData?.textContent.trim()) {
      try {
        const variant = JSON.parse(variantData.textContent);
        sticky.querySelector('.hpg-mobile-sticky-cart__name').textContent = variant.title;
        if (variant.featured_media?.preview_image?.src) {
          sticky.querySelector('.hpg-mobile-sticky-cart__image').src = `${variant.featured_media.preview_image.src}&width=120`;
        }
      } catch (_) {}
    }
  }

  applyLayout();
  updateSticky();
  mobile.addEventListener('change', () => {
    applyLayout();
    syncStickyVisibility();
  });

  if (realButton && sticky) {
    syncStickyVisibility = () => {
      const drawerOpen = document.querySelector('cart-drawer.active, cart-drawer[open]');
      const buttonIsAboveViewport = realButton.getBoundingClientRect().bottom < 0;
      setStickyVisible(mobile.matches && buttonIsAboveViewport && !drawerOpen);
    };

    new IntersectionObserver(syncStickyVisibility, { threshold: 0 }).observe(realButton);
    window.addEventListener('scroll', syncStickyVisibility, { passive: true });
    window.addEventListener('resize', syncStickyVisibility);
    syncStickyVisibility();

    sticky.querySelector('[data-hpg-sticky-scroll]').addEventListener('click', () => {
      document.getElementById('hpg-set-selector')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    sticky.querySelector('[data-hpg-sticky-cta]').addEventListener('click', () => {
      const buttonBottom = window.scrollY + realButton.getBoundingClientRect().bottom;
      window.scrollTo({ top: buttonBottom - window.innerHeight + 16, behavior: 'smooth' });
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#hpg-set-selector"]');
    if (!link) return;
    event.preventDefault();
    document.getElementById('hpg-set-selector')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('variant:change', updateSticky);
  document.addEventListener('change', () => window.setTimeout(updateSticky));
  new MutationObserver(() => {
    updateSticky();
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) setStickyVisible(false);
  }).observe(info, { childList: true, subtree: true });

  if (mobileSummary) {
    new MutationObserver(updateSticky).observe(mobileSummary, { childList: true, subtree: true });
  }

  new MutationObserver(() => {
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) setStickyVisible(false);
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
})();
